<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisiable"
      size="70%"
      :show-close="false"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <template slot="title">
        <div class="my__dialog__header">
          <span class="el-dialog__title">
            <span v-if="!isShowPayCode">{{ dialogTitle }}</span>
            <span v-else class="paycode-title">
              请在 <span class="minute">15:00</span> 分钟内完成支付
            </span>
          </span>
        </div>
      </template>
      <div v-if="!isShowPayCode">
        <div
          class="pay-item"
          :class="{ active: activeIndex === index }"
          v-for="(item, index) in payModeList"
          :key="item.value"
          @click="toSelectPayMode(index)"
        >
          <img :src="item.payImg" :alt="item.label" class="wechatpay-img" />
          <div>
            <img
              v-if="activeIndex === index"
              src="../../assets/radio-select.png"
              alt="选中"
              class="radio-img"
            />
            <img
              v-else
              src="../../assets/radio.png"
              alt="未选中"
              class="radio-img"
            />
          </div>
        </div>
      </div>
      <div v-else class="paycode-container">
        <!-- 二维码区 -->
        <div
          class="qrcode-container"
          :style="{ 'border-color': activeIndex === 0 ? '#19AB18' : '#3998fe' }"
        >
          <div id="qrcode" ref="qrcode"></div>
        </div>
        <el-button type="primary" @click="toCheckIsComplete"
          >完成支付</el-button
        >
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isShowPayCode">
        <div v-if="dialogTitle === '支付方式'" class="btn-list">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="confirmPayMode">确 定</el-button>
        </div>
        <el-button v-else>完成支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createOrder, payOrder, getOrderDetail } from "@/api/home";
import QRCode from "qrcodejs2";
export default {
  props: {
    confirmInfo: {
      type: Object,
      default: null,
    },
    haveOrderNo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogTitle: "支付方式",
      dialogVisiable: true,
      payModeList: [
        {
          value: 1,
          label: "微信",
          payImg: require("../../assets/wechat-pay.png"),
        },
        {
          value: 2,
          label: "支付宝",
          payImg: require("../../assets/ali-pay.png"),
        },
      ],
      activeIndex: 0,
      isShowPayCode: false, //是否显示二维码
      isBtnLoading: false,
      orderNo: "",
    };
  },
  methods: {
    // 完成支付 获取订单详情 -> 状态
     async toCheckIsComplete() {
      const { data } = await getOrderDetail({
        order_no: this.orderNo,
      });
      console.log(data, "data");
      if (data.status == 1) {
        //待支付
        this.$confirm("该订单未支付, 是否继续支付?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {})
          .catch(() => {
            console.log("quxiao ");
            // 取消
            // TO DO 前往个人中心订单 待支付
            this.handleClose();
            this.$router.push({
              name: "Personal"
            });
            localStorage.setItem('status',1)
          });
      } else {
        this.handleClose();
        this.$router.push({
          name: "Personal",
        });
        localStorage.setItem('status','')
      }
    },
    // 创建订单
    async confirmPayMode() {
      console.log(this.confirmInfo, "createOrder");
      let qrCodeText = "";
      if (this.confirmInfo.orderNo) {
        this.orderNo = this.confirmInfo.orderNo;
        if (this.activeIndex === 1) {
          //支付宝
          const resp = await payOrder({
            order_no: this.confirmInfo.orderNo,
            pay_type: 2,
          });
          console.log(resp, "data支付宝");
          qrCodeText = resp.data;
        } else {
          qrCodeText = `https://m.tik178.com/order-detail?payFrom=pc&orderNo=${this.confirmInfo.orderNo}`;
        }
        this.isShowPayCode = true;
        console.log(qrCodeText, "qrCodeText");
        this.$nextTick(() => {
          this.$refs.qrcode.innerHTML = "";
          console.log(this.$refs.qrcode, "qrcode");
          let qrcode = new QRCode("qrcode", {
            text: qrCodeText, // 需要转换为二维码的内容
            width: 184,
            height: 184,
          });
        });
      } else {
        const res = await createOrder(this.confirmInfo);
        console.log(res, "data");
        if (res.data.order_no) {
          if(this.confirmInfo.is_cart == 1) {
            // 重新获取购物车
            this.$store.dispatch('cart/getCartNum')
          }
          this.orderNo = res.data.order_no;
          if (this.activeIndex === 1) {
            //支付宝
            const resp = await payOrder({
              order_no: res.data.order_no,
              pay_type: 2,
            });
            console.log(resp, "data支付宝");
            qrCodeText = resp.data;
          } else {
            qrCodeText = `https://m.tik178.com/order-detail?payFrom=pc&orderNo=${res.data.order_no}`;
          }
          this.isShowPayCode = true;
          console.log(qrCodeText, "qrCodeText");
          this.$nextTick(() => {
            this.$refs.qrcode.innerHTML = "";
            console.log(this.$refs.qrcode, "qrcode");
            let qrcode = new QRCode("qrcode", {
              text: qrCodeText, // 需要转换为二维码的内容
              width: 184,
              height: 184,
            });
          });
        }else {
          this.$message(res.msg)
        }
      }
    },
    toSelectPayMode(index) {
      this.activeIndex = index;
    },
    handleClose() {
      this.dialogVisiable = false;
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.pay-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid @tipwords;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 10px 20px;
  cursor: pointer;
}
.pay-item.active {
  border-color: @primary;
}
.wechatpay-img {
  width: auto;
  height: 30px;
}
.my__dialog__header {
  text-align: center;
}
.radio-img {
  width: 40px;
  height: auto;
}
.qrcode-container {
  width: 218px;
  height: 218px;
  border-radius: 12px;
  border: 4px solid #19ab18;
  margin: 0 auto 43px;
  /deep/ img {
    padding: 17px;
  }
}
.paycode-container {
  text-align: center;
}
.paycode-title {
  margin-top: 20px;
  font-size: 18px;
  font-weight: 400;
  color: @words;
  > .minute {
    color: @primary;
  }
}
</style>